module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.show) ? _c('div', {
    staticClass: "wxc-minibar weex-ct weex-div",
    style: (_vm._px2rem(_vm.newBarStyle, 75)),
    attrs: {
      "weex-type": "div"
    }
  }, [_c('div', {
    staticClass: "left weex-ct weex-div",
    attrs: {
      "aria-label": "返回",
      "accessible": true,
      "weex-type": "div",
      "data-evt-click": ""
    },
    on: {
      "click": _vm.$stopOuterA,
      "weex$tap": function($event) {
        $event.stopPropagation();
        return _vm.leftButtonClicked($event)
      }
    }
  }, [_vm._t("left", [(_vm.leftButton && !_vm.leftText) ? _c('figure', {
    staticClass: "left-button weex-el weex-image",
    attrs: {
      "src": _vm.leftButton,
      "data-img-src": _vm.leftButton,
      "weex-type": "image"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.leftText) ? _c('p', {
    staticClass: "icon-text weex-el weex-text",
    style: ({
      color: _vm.textColor
    }),
    attrs: {
      "weex-type": "text"
    }
  }, [_vm._v(_vm._s(_vm.leftText))]) : _vm._e()], {})], 2), _vm._v(" "), _vm._t("middle", [_c('p', {
    staticClass: "middle-title weex-el weex-text",
    style: ({
      color: _vm.textColor
    }),
    attrs: {
      "weex-type": "text"
    }
  }, [_vm._v(_vm._s(_vm.title))])], {}), _vm._v(" "), _c('div', {
    staticClass: "right weex-ct weex-div",
    attrs: {
      "weex-type": "div",
      "data-evt-click": ""
    },
    on: {
      "click": _vm.$stopOuterA,
      "weex$tap": function($event) {
        $event.stopPropagation();
        return _vm.rightButtonClicked($event)
      }
    }
  }, [_vm._t("right", [(_vm.rightButton && !_vm.rightText) ? _c('figure', {
    staticClass: "right-button weex-el weex-image",
    attrs: {
      "src": _vm.rightButton,
      "aria-hidden": true,
      "data-img-src": _vm.rightButton,
      "weex-type": "image"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.rightText) ? _c('p', {
    staticClass: "icon-text weex-el weex-text",
    style: ({
      color: _vm.textColor
    }),
    attrs: {
      "weex-type": "text"
    }
  }, [_vm._v(_vm._s(_vm.rightText))]) : _vm._e()], {})], 2)], 2) : _vm._e()
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-d1f4ac0a", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-d1f4ac0a","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./packages/wxc-minibar/index.vue
// module id = 242
// module chunks = 0 1